// @flow
import * as React from "react";
import PairDetailTabs from "../components/PairDetailTabs";

export const CapPairActivity = PairDetailTabs(
  React.lazy(() => import("./containers/PairActivityPage")),
);

/* PAGE HANDLED BY ../PairRoutes.jsx */
